<template>

  <v-row class="form-wrapper" data-app>
    <Stepper v-if="$store.state.formPageNumber > 0 && $store.state.formPageNumber < 8"></Stepper>
    <Decleration v-if="$store.state.formPageNumber === 0"></Decleration>
    <PersonalInformation v-if="$store.state.formPageNumber === 1"></PersonalInformation>
    <YatchDetail v-if="$store.state.formPageNumber === 2"></YatchDetail>
    <YatchUsage v-if="$store.state.formPageNumber === 3"></YatchUsage>
    <InsuredValue v-if="$store.state.formPageNumber === 4"></InsuredValue>
    <PolicyDetails v-if="$store.state.formPageNumber === 5"></PolicyDetails>
    <ClaimsRecord v-if="$store.state.formPageNumber === 6"></ClaimsRecord>
    <ConfirmationPage v-if="$store.state.formPageNumber === 7"></ConfirmationPage>
    <Success v-if="$store.state.formPageNumber === 8"></Success>

    <PersonalInfoCollectionStatement v-if="$store.state.formPageNumber === -1"></PersonalInfoCollectionStatement>
    <PrivacyPolicy v-if="$store.state.formPageNumber === -2"></PrivacyPolicy>
    <TermAndUse v-if="$store.state.formPageNumber === -3"></TermAndUse>
  </v-row>
</template>

<script>
import Stepper from "./FormComponents/Stepper.vue";
import PersonalInformation from "./FormComponents/PersonalInformation.vue";
import PersonalInfoCollectionStatement from "@/components/FormComponents/PersonalInfoCollectionStatement";
import YatchDetail from "./FormComponents/YatchDetail.vue";
import YatchUsage from "./FormComponents/YatchUsage.vue";
import InsuredValue from "./FormComponents/InsuredValue.vue";
import PolicyDetails from "./FormComponents/PolicyDetails.vue";
import ClaimsRecord from "./FormComponents/ClaimsRecord.vue";
import ConfirmationPage from "./FormComponents/ConfirmationPage.vue";
import Decleration from "./FormComponents/Decleration.vue";
import Success from "./FormComponents/Success.vue";
import PrivacyPolicy from "@/components/FormComponents/PrivacyPolicy";
import TermAndUse from "@/components/FormComponents/TermAndUse";

export default {
  name: "Form",
  components: {
    TermAndUse,
    Stepper,
    PersonalInformation,
    YatchDetail,
    YatchUsage,
    InsuredValue,
    PolicyDetails,
    ClaimsRecord,
    ConfirmationPage,
    Decleration,
    Success,
    PersonalInfoCollectionStatement,
    PrivacyPolicy
  },
};
</script>
